import { Endpoint } from "@rest-hooks/endpoint";
export const BuyoutSettingsEndpoint = new Endpoint(() => fetch("/buyout/settings").then(r => r.json()), {
    key: () => `buyout-settings`,
    dataExpiryLength: 1000 * 60 * 60
});
//# sourceMappingURL=BuyoutSettings.js.map